var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useState, useRef, useEffect, useLayoutEffect, useContext } from 'react';
import { t } from 'i18next';
import ButtonComponent from './ButtonComponent';
import Popup from './Popup';
import ViewCodeModal from './ViewCodeModal';
import { getImageSrc } from '../helper/imageBlobCache';
import { DataContext } from '../player/DataContext';
import customEventHandler from '../helper/customEvents';
import { APP_URL } from '../config/api';
import { formatShareCode } from '../helper/shareCode';
import { copyTextToClipboard } from '../helper/clipboardHelper';
import { renameShareCodeLabel } from '../helper/saveShareCode';
import globalStore from '../store';
var ShareMenu = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    var position = _a.position, code = _a.code, onClose = _a.onClose, onCopyFeedback = _a.onCopyFeedback;
    var menuRef = useRef(null);
    var btnConfig = globalStore.useStoreState(function (state) { return state.jsonDataStore; }).btnConfig;
    var _1 = globalStore.useStoreState(function (state) { return state.playerStore; }), isIDM = _1.isIDM, pageData = _1.pageData, contentShareable = _1.contentShareable, shareCode = _1.shareCode;
    // Share Link / Copy Code are gated for the OPEN activity's row only.
    //
    // Scope matters in both directions. Gating globally greys out unrelated,
    // perfectly shareable rows; not gating at all leaves the open activity's own
    // row able to hand out a code for content the author marked non-shareable.
    //
    // This is now the ONLY restriction the panel applies. The code display is
    // never withheld — the panel prints every row's code and names it on every
    // accessible name (see the note where `hideShareCodes` was removed, below).
    // Withholding distribution while showing the owner their own code is the
    // whole of the product decision.
    //
    // KNOWN LIMITATION: rows OTHER than the open activity cannot be judged at
    // all, because `GET /share-codes` returns no per-code `shareable`. A
    // restricted code sitting in the list while a different activity is open is
    // therefore still copyable. Closing that needs the API to return the flag
    // per entry; it is recorded in docs/player/ShareRestriction.md.
    //
    // Explicit `=== false` so a store that omits the field never reads as
    // restricted. See IwbSharePopup.
    var isOpenActivityRow = !!shareCode && formatShareCode(code) === formatShareCode(shareCode);
    var shareBlocked = contentShareable === false && isOpenActivityRow;
    var pdfExists = pageData.some(function (page) { var _a; return /\.pdf(\?|$)/i.test((_a = page === null || page === void 0 ? void 0 : page.background) !== null && _a !== void 0 ? _a : ''); });
    useEffect(function () {
        var handleClickOutside = function (e) {
            if (menuRef.current && !menuRef.current.contains(e.target))
                onClose();
        };
        var handleEsc = function (e) {
            if (e.key === 'Escape')
                onClose();
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEsc);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEsc);
        };
    }, [onClose]);
    // Writes `text` to the clipboard, closes the menu, and reports the outcome
    // back to the parent so it can render the confirmation popup. Falls back
    // gracefully when the Clipboard API isn't available (older browsers, non-
    // https contexts) — the failure case still surfaces "an issue occurred".
    var copyAndReport = function (text, kind) { return __awaiter(void 0, void 0, void 0, function () {
        var ok;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onClose();
                    return [4 /*yield*/, copyTextToClipboard(text)];
                case 1:
                    ok = _a.sent();
                    onCopyFeedback(kind, ok);
                    return [2 /*return*/];
            }
        });
    }); };
    // Trigger a "copy image" — the actual screenshot capture and clipboard
    // write live in WhiteBoard's `copyMainHolderScreenshotToClipboard`, which
    // dispatches a `screenshotCopied` event with `{ ok: boolean }` once it's
    // done. We register a one-shot listener so the parent's confirmation
    // popup surfaces success / failure exactly like the link/code variants.
    var copyImageAndReport = function () {
        onClose();
        var handler = function (data) {
            customEventHandler.removeEventListener('screenshotCopied', handler);
            onCopyFeedback('image', !!(data === null || data === void 0 ? void 0 : data.ok), data === null || data === void 0 ? void 0 : data.reason, data === null || data === void 0 ? void 0 : data.info);
        };
        customEventHandler.addEventListener('screenshotCopied', handler);
        customEventHandler.dispatchEvent('headerClicked', { id: 'copySS' });
    };
    // Trigger a "download / share image". Like copy, WhiteBoard dispatches a
    // `screenshotCopied` event once the capture + save finishes, carrying the
    // saved image's size + dimensions — surfacing them confirms what was saved
    // and makes the iPad "0-byte / blank" capture visible instead of silent.
    var downloadImageAndReport = function () {
        onClose();
        var handler = function (data) {
            customEventHandler.removeEventListener('screenshotCopied', handler);
            onCopyFeedback('image', !!(data === null || data === void 0 ? void 0 : data.ok), data === null || data === void 0 ? void 0 : data.reason, data === null || data === void 0 ? void 0 : data.info);
        };
        customEventHandler.addEventListener('screenshotCopied', handler);
        customEventHandler.dispatchEvent('headerClicked', { id: 'downloadSS' });
    };
    var items = [
        {
            label: t('text.shareAnImage'),
            icon: (_d = (_c = (_b = btnConfig.iwbShareImage) === null || _b === void 0 ? void 0 : _b.imgSrc) === null || _c === void 0 ? void 0 : _c.normal) !== null && _d !== void 0 ? _d : './assets/images/shareLabel/shareImgN.svg',
            iconHover: (_g = (_f = (_e = btnConfig.iwbShareImage) === null || _e === void 0 ? void 0 : _e.imgSrc) === null || _f === void 0 ? void 0 : _f.hover) !== null && _g !== void 0 ? _g : './assets/images/shareLabel/shareImgH.svg',
            action: function () {
                downloadImageAndReport();
            },
            disabled: false,
        },
        {
            label: t('text.copyImage'),
            icon: (_k = (_j = (_h = btnConfig.iwbCopyImage) === null || _h === void 0 ? void 0 : _h.imgSrc) === null || _j === void 0 ? void 0 : _j.normal) !== null && _k !== void 0 ? _k : './assets/images/shareLabel/copyN.svg',
            iconHover: (_o = (_m = (_l = btnConfig.iwbCopyImage) === null || _l === void 0 ? void 0 : _l.imgSrc) === null || _m === void 0 ? void 0 : _m.hover) !== null && _o !== void 0 ? _o : './assets/images/shareLabel/copyN.svg',
            action: function () {
                copyImageAndReport();
            },
            disabled: false,
        },
        {
            label: t('text.shareLink'),
            icon: (_r = (_q = (_p = btnConfig.iwbShareLink) === null || _p === void 0 ? void 0 : _p.imgSrc) === null || _q === void 0 ? void 0 : _q.normal) !== null && _r !== void 0 ? _r : './assets/images/shareLabel/generateN.svg',
            iconHover: (_u = (_t = (_s = btnConfig.iwbShareLink) === null || _s === void 0 ? void 0 : _s.imgSrc) === null || _t === void 0 ? void 0 : _t.hover) !== null && _u !== void 0 ? _u : './assets/images/shareLabel/generateH.svg',
            action: function () {
                if (shareBlocked)
                    return;
                copyAndReport("".concat(APP_URL, "/?").concat(formatShareCode(code)), 'link');
            },
            disabled: shareBlocked,
        },
        {
            label: t('text.copyCode'),
            icon: (_x = (_w = (_v = btnConfig.iwbCopyCode) === null || _v === void 0 ? void 0 : _v.imgSrc) === null || _w === void 0 ? void 0 : _w.normal) !== null && _x !== void 0 ? _x : './assets/images/shareLabel/copyN.svg',
            iconHover: (_0 = (_z = (_y = btnConfig.iwbCopyCode) === null || _y === void 0 ? void 0 : _y.imgSrc) === null || _z === void 0 ? void 0 : _z.hover) !== null && _0 !== void 0 ? _0 : './assets/images/shareLabel/copyN.svg',
            action: function () {
                if (shareBlocked)
                    return;
                copyAndReport(formatShareCode(code), 'code');
            },
            disabled: shareBlocked,
        },
    ];
    useEffect(function () {
        var handleKeyDown = function (e) {
            var _a;
            if (e.key === 'Escape') {
                onClose();
                return;
            }
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                var buttons = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('button');
                if (!(buttons === null || buttons === void 0 ? void 0 : buttons.length))
                    return;
                var current = document.activeElement;
                var idx = Array.from(buttons).indexOf(current);
                var next = e.key === 'ArrowDown'
                    ? (idx + 1) % buttons.length
                    : (idx - 1 + buttons.length) % buttons.length;
                buttons[next].focus();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return function () { return document.removeEventListener('keydown', handleKeyDown); };
    }, [onClose]);
    useEffect(function () {
        var _a;
        var firstBtn = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('button');
        if (firstBtn)
            firstBtn.focus();
    }, []);
    // Clamp the menu to the viewport. The position passed in is anchored to
    // the trigger row's top, but for rows near the bottom of the screen the
    // menu would otherwise spill below the viewport. After mount, measure the
    // rendered height and shift the menu up so its bottom sits within an 8px
    // gutter from `window.innerHeight`. Rows that fit normally are left at
    // their original top.
    var _2 = useState(position.top), adjustedTop = _2[0], setAdjustedTop = _2[1];
    useLayoutEffect(function () {
        var el = menuRef.current;
        if (!el)
            return;
        var VIEWPORT_MARGIN = 8;
        var height = el.offsetHeight;
        var maxTop = window.innerHeight - height - VIEWPORT_MARGIN;
        if (position.top > maxTop) {
            setAdjustedTop(Math.max(VIEWPORT_MARGIN, maxTop));
        }
        else {
            setAdjustedTop(position.top);
        }
    }, [position.top, position.left]);
    return (_jsx("div", { ref: menuRef, className: "iwb-shareMenu", style: { top: adjustedTop, left: position.left }, role: "menu", "aria-label": t('text.share'), 
        // Prevent the click-outside handler (mousedown) from firing for clicks
        // *inside* the menu — without this, mousedown on a button bubbles to
        // document before the click handler runs and closes the menu first.
        onMouseDown: function (e) {
            e.stopPropagation();
        }, children: items.map(function (item, idx) { return (_jsxs(Fragment, { children: [_jsx(ButtonComponent, { defaultCSS: "iwb-shareMenuItem", normalCSS: "iwb-shareMenuItem", imgSrc: { normal: item.icon, hover: item.iconHover }, imgWidth: 20, imgHeight: 20, type: "imageType1", ariaLabel: item.label, disabled: item.disabled, clickHandler: function (e) {
                        var _a, _b;
                        (_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
                        (_b = e === null || e === void 0 ? void 0 : e.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(e);
                        if (item.disabled)
                            return;
                        item.action();
                    }, noAudio: true, children: _jsx("span", { className: "iwb-shareMenuLabel", children: item.label }) }), idx < items.length - 1 && _jsx("hr", { "aria-hidden": "true" })] }, item.label)); }) }));
};
var CollapsibleSection = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var section = _a.section, depth = _a.depth, selectedSet = _a.selectedSet, onCheckToggle = _a.onCheckToggle, onRenameSection = _a.onRenameSection, onRemoveSection = _a.onRemoveSection, sortMode = _a.sortMode, onSetSort = _a.onSetSort, onLabelRenamed = _a.onLabelRenamed, onToggleFavourite = _a.onToggleFavourite, onMoveToSection = _a.onMoveToSection, _v = _a.sectionNames, sectionNames = _v === void 0 ? [] : _v, isExpandedProp = _a.isExpanded, onToggleExpand = _a.onToggleExpand;
    var _w = useContext(DataContext), setShowEnterKeyModal = _w.setShowEnterKeyModal, setEnterKeyPrefill = _w.setEnterKeyPrefill, setEnterKeyPrefillLabel = _w.setEnterKeyPrefillLabel;
    // Pull button image configs from btnData.json so we don't hardcode asset
    // paths in JSX. Icons that don't have a dedicated entry in btnData fall
    // back to inline paths until a config is added.
    var btnConfig = globalStore.useStoreState(function (state) { return state.jsonDataStore; }).btnConfig;
    // Read ONLY to gate code DISTRIBUTION, never its display — see the note
    // immediately below. The panel's other distribution gate, `shareBlocked`, is
    // in the entry share menu above.
    var contentShareable = globalStore.useStoreState(function (state) { return state.playerStore; }).contentShareable;
    // THE SAVED-WORK LIST NEVER MASKS A CODE. Every row prints its own code, and
    // every accessible name on that row announces it, whatever the open
    // activity's `shareable` flag says.
    //
    // This reverses the code-*display* half of ShareRestriction — the
    // `hideShareCodes = contentShareable === false` derivation that used to live
    // here and rendered `••••-••••` in the code box. Product decision,
    // 2026-09-02: a masked code must never appear, including while a
    // non-shareable activity is open. The masking was global rather than per
    // row (`GET /share-codes` returns no per-code `shareable`), so rows for
    // unrelated, perfectly shareable saved work were masked too — which is the
    // form the user kept hitting.
    //
    // What is NOT reversed: the code-*distribution* gates. `contentShareable`
    // still disables Copy Link / Copy Code — `shareBlocked` in the entry share
    // menu above, scoped to the open activity's row, and the same gate in
    // IwbSharePopup — and it still suppresses ViewCodeModal's copy-on-OK via
    // `copyOnConfirm` below. Showing users a code for work they saved is not the
    // same as handing them an affordance to distribute it.
    //
    // NOT a gate, despite what docs/player/ShareRestriction.md still claims:
    // "Display Code" in InputWithBtn (and in IwbSharePopup) has no `disabled`
    // prop at all. That gate was lost some time before this change, not by it;
    // filed separately. Do not cite it as a retained restriction.
    //
    // Do not reintroduce a masked branch here without a product call asking for
    // it — this has now flipped three times (de7138fc removed it, d926cdec
    // restored it, PR #326 was closed for removing it again). See
    // docs/player/ShareRestriction.md.
    var _x = useState(false), localExpanded = _x[0], setLocalExpanded = _x[1];
    var expanded = isExpandedProp !== undefined ? isExpandedProp : localExpanded;
    // Tracks which entry rows have their label expanded (full text shown
    // instead of the default ellipsised single-line). Click toggles, so touch
    // users — who don't get native `title` hover — can still see the full
    // saved-activity name.
    // Per-folder "Sort by" menu, anchored under this section's sort button.
    var _y = useState(false), sortMenuOpen = _y[0], setSortMenuOpen = _y[1];
    var sortMenuRef = useRef(null);
    // In-progress label edits, keyed by entry id. An entry is absent until the
    // user types, so rows normally render the value straight from the server and
    // a refetch is free to update them underneath.
    var _z = useState({}), draftLabels = _z[0], setDraftLabels = _z[1];
    var _0 = useState(null), renamingId = _0[0], setRenamingId = _0[1];
    var _1 = useState({
        show: false,
        code: '',
    }), viewCodeEntry = _1[0], setViewCodeEntry = _1[1];
    // Commented out with the per-row Share button below (client request) rather
    // than deleted, so the whole ShareMenu entry point can be restored in one
    // place. Nothing else reads this state.
    // const [shareMenu, setShareMenu] = useState<{
    //   top: number;
    //   left: number;
    //   code: string;
    //   entryId: string;
    // } | null>(null);
    // Confirmation popup for the ShareMenu's Copy Code / Copy Link / Copy
    // Image actions. `kind` picks the success message ("link copied" /
    // "code copied" / "image copied") and `ok` flips it to the failure
    // variant ("an issue occurred"). Mirrors the share popup feedback in
    // InputWithBtn so users get the same confirmation regardless of which
    // entry-point they used to copy.
    var _2 = useState(null), copyFeedback = _2[0], setCopyFeedback = _2[1];
    // `?? ''` is not cosmetic: a section that reaches here without a `titleKey`
    // threw on `.startsWith`, and because this component renders inside the panel
    // body that took the WHOLE save panel down — one malformed row from the
    // groups response and the user loses the entire list. Found by feeding the
    // e2e stub the wrong response shape.
    var titleKey = (_b = section.titleKey) !== null && _b !== void 0 ? _b : '';
    var title = titleKey.startsWith('text.') ? t(titleKey) : titleKey;
    /**
     * Persist an edited label, then drop the draft so the row goes back to
     * rendering the server's value.
     *
     * A no-op when the text is unchanged — blur fires on every click-away, and
     * without this guard simply tabbing through the list would re-post every
     * record it passed. `onLabelRenamed` refreshes the list; if the write fails
     * the draft is discarded so the row visibly snaps back rather than showing a
     * name that was never saved.
     */
    var commitLabel = function (entry) { return __awaiter(void 0, void 0, void 0, function () {
        var draft, trimmed, clearDraft, ok;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    draft = draftLabels[entry.id];
                    if (draft === undefined)
                        return [2 /*return*/];
                    trimmed = draft.trim();
                    clearDraft = function () {
                        return setDraftLabels(function (prev) {
                            var next = __assign({}, prev);
                            delete next[entry.id];
                            return next;
                        });
                    };
                    if (trimmed === entry.label.trim()) {
                        clearDraft();
                        return [2 /*return*/];
                    }
                    setRenamingId(entry.id);
                    return [4 /*yield*/, renameShareCodeLabel(entry.code, trimmed)];
                case 1:
                    ok = _a.sent();
                    setRenamingId(null);
                    clearDraft();
                    onLabelRenamed === null || onLabelRenamed === void 0 ? void 0 : onLabelRenamed(ok);
                    return [2 /*return*/];
            }
        });
    }); };
    // Close the sort menu on an outside click or Escape, matching how the row
    // share menu behaves.
    useEffect(function () {
        if (!sortMenuOpen)
            return;
        var onPointerDown = function (e) {
            if (sortMenuRef.current && !sortMenuRef.current.contains(e.target)) {
                setSortMenuOpen(false);
            }
        };
        var onEsc = function (e) {
            if (e.key === 'Escape')
                setSortMenuOpen(false);
        };
        document.addEventListener('pointerdown', onPointerDown);
        document.addEventListener('keydown', onEsc);
        return function () {
            document.removeEventListener('pointerdown', onPointerDown);
            document.removeEventListener('keydown', onEsc);
        };
    }, [sortMenuOpen]);
    var toggleExpand = function () {
        if (onToggleExpand) {
            onToggleExpand(section.id);
        }
        else {
            setLocalExpanded(!localExpanded);
        }
    };
    // Determine section icon — pulled from btnData so the asset paths stay
    // centralised. Falls back to inline paths if the JSON entry is missing.
    // Regular folders deliberately do NOT fall back through `btnConfig.iwbAddFolder`
    // — that entry is the "+" add-folder action button's own icon (see its usage
    // in InputWithBtn.tsx), and reusing it here put a "+" badge on every existing
    // folder row instead of a plain folder.
    var sectionIcon = section.id === 'favourites'
        ? ((_e = (_d = (_c = btnConfig.iwbFavouritesIcon) === null || _c === void 0 ? void 0 : _c.imgSrc) === null || _d === void 0 ? void 0 : _d.normal) !== null && _e !== void 0 ? _e : './assets/images/icons/favouriteH.svg')
        : section.id === 'ungrouped'
            ? ((_h = (_g = (_f = btnConfig.iwbUncategorizedIcon) === null || _f === void 0 ? void 0 : _f.imgSrc) === null || _g === void 0 ? void 0 : _g.normal) !== null && _h !== void 0 ? _h : './assets/images/shareLabel/uncatIcon.svg')
            : './assets/images/shareLabel/folderIcon.svg';
    // Rename / delete are meaningless on the two synthetic sections. Sort is NOT
    // gated this way — the client asked for a Sort by control on every folder
    // name "including Favorites and Uncategorized".
    var showFolderActions = section.id !== 'favourites' && section.id !== 'ungrouped';
    var showSectionTools = showFolderActions || !!onSetSort;
    return (_jsxs("div", { className: "iwb-section ".concat(depth > 0 ? 'iwb-subsection' : ''), children: [_jsxs("div", { className: "iwb-sectionHeader", role: "button", tabIndex: 0, "aria-expanded": expanded, "aria-label": "".concat(title, ", ").concat(expanded ? t('text.collapse') : t('text.expand')), onClick: function () {
                    // The action-button wrapper stops click propagation, so any click
                    // that reaches the header should toggle (chevron / icon / title).
                    toggleExpand();
                }, onKeyDown: function (e) {
                    // Don't toggle when Enter/Space comes from a focused child button.
                    if (e.target !== e.currentTarget)
                        return;
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggleExpand();
                    }
                    else if (showFolderActions && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
                        // Roving navigation between header and inline action buttons.
                        e.preventDefault();
                        e.stopPropagation();
                        var btns = e.currentTarget.querySelectorAll('.iwb-sectionAction');
                        if (btns.length > 0) {
                            btns[e.key === 'ArrowRight' ? 0 : btns.length - 1].focus();
                        }
                    }
                }, children: [_jsx("span", { className: "iwb-chevron ".concat(expanded ? 'iwb-chevronExpanded' : ''), "aria-hidden": "true", children: _jsx("img", { src: getImageSrc((_l = (_k = (_j = btnConfig.iwbChevron) === null || _j === void 0 ? void 0 : _j.imgSrc) === null || _k === void 0 ? void 0 : _k.normal) !== null && _l !== void 0 ? _l : './assets/images/icons/down_arrow.png'), alt: "", className: "iwb-chevronImg" }) }), _jsx("img", { className: "iwb-sectionIcon", src: getImageSrc(sectionIcon), alt: "", "aria-hidden": "true" }), _jsx("span", { className: "iwb-sectionTitle", children: title }), showSectionTools && (_jsxs("div", { className: "iwb-sectionActions", onClick: function (e) { return e.stopPropagation(); }, onKeyDown: function (e) {
                            if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                                e.preventDefault();
                                e.stopPropagation();
                                var btns = Array.from(e.currentTarget.querySelectorAll('.iwb-sectionAction'));
                                var idx = btns.indexOf(document.activeElement);
                                if (idx === -1)
                                    return;
                                var next = e.key === 'ArrowRight'
                                    ? (idx + 1) % btns.length
                                    : (idx - 1 + btns.length) % btns.length;
                                btns[next].focus();
                            }
                        }, children: [showFolderActions && (_jsxs(_Fragment, { children: [_jsx(ButtonComponent, { defaultCSS: "iwb-sectionAction iwb-sectionEditBtn", normalCSS: "iwb-sectionAction iwb-sectionEditBtn", imgSrc: (_m = btnConfig.iwbEdit) === null || _m === void 0 ? void 0 : _m.imgSrc, type: "imageType1", ariaLabel: "".concat(t('text.renameFolder'), ": ").concat(title), title: t('text.renameFolder'), showToolTip: true, direction: "bottom", useViewportPosition: true, clickHandler: function (e) {
                                            var _a, _b;
                                            (_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
                                            (_b = e === null || e === void 0 ? void 0 : e.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(e);
                                            onRenameSection === null || onRenameSection === void 0 ? void 0 : onRenameSection(section.id);
                                        }, noAudio: true }), _jsx(ButtonComponent, { defaultCSS: "iwb-sectionAction iwb-sectionDeleteBtn", normalCSS: "iwb-sectionAction iwb-sectionDeleteBtn", imgSrc: (_o = btnConfig.iwbRemove) === null || _o === void 0 ? void 0 : _o.imgSrc, type: "imageType1", ariaLabel: "".concat(t('text.removeFolder'), ": ").concat(title), title: t('text.removeFolder'), showToolTip: true, direction: "bottom", useViewportPosition: true, clickHandler: function (e) {
                                            var _a, _b;
                                            (_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
                                            (_b = e === null || e === void 0 ? void 0 : e.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(e);
                                            onRemoveSection === null || onRemoveSection === void 0 ? void 0 : onRemoveSection(section.id);
                                        }, noAudio: true })] })), onSetSort && (_jsxs("div", { className: "iwb-sortWrapper", ref: sortMenuRef, children: [_jsx(ButtonComponent, { defaultCSS: "iwb-sectionAction iwb-sectionSortBtn", normalCSS: "iwb-sectionAction iwb-sectionSortBtn", imgSrc: (_p = btnConfig.iwbSort) === null || _p === void 0 ? void 0 : _p.imgSrc, type: "imageType1", ariaLabel: "".concat(t('text.sortBy'), ": ").concat(title), title: t('text.sortBy'), showToolTip: true, direction: "bottom", useViewportPosition: true, ariaExpanded: sortMenuOpen, clickHandler: function (e) {
                                            var _a, _b;
                                            (_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
                                            (_b = e === null || e === void 0 ? void 0 : e.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(e);
                                            setSortMenuOpen(function (prev) { return !prev; });
                                        }, noAudio: true }), sortMenuOpen && (_jsxs("div", { className: "iwb-sortMenu", role: "menu", "aria-label": t('text.sortBy'), children: [_jsx(ButtonComponent, { defaultCSS: "iwb-sortMenuItem", text: t('text.sortByName'), ariaLabel: t('text.sortByName'), role: "menuitemradio", ariaChecked: sortMode === 'name', clickHandler: function (e) {
                                                    var _a, _b;
                                                    (_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
                                                    (_b = e === null || e === void 0 ? void 0 : e.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(e);
                                                    onSetSort(section.id, 'name');
                                                    setSortMenuOpen(false);
                                                }, noAudio: true }), _jsx(ButtonComponent, { defaultCSS: "iwb-sortMenuItem", text: t('text.sortByMostRecent'), ariaLabel: t('text.sortByMostRecent'), role: "menuitemradio", ariaChecked: sortMode === 'modified', clickHandler: function (e) {
                                                    var _a, _b;
                                                    (_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
                                                    (_b = e === null || e === void 0 ? void 0 : e.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(e);
                                                    onSetSort(section.id, 'modified');
                                                    setSortMenuOpen(false);
                                                }, noAudio: true })] }))] }))] }))] }), expanded && (_jsxs("div", { className: "iwb-sectionContent", role: "list", "aria-label": title, onKeyDown: function (e) {
                    var _a;
                    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                        e.preventDefault();
                        e.stopPropagation();
                        var rows = Array.from(e.currentTarget.querySelectorAll('.iwb-entryRow, .iwb-sectionHeader'));
                        var currentRow = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.closest('.iwb-entryRow, .iwb-sectionHeader');
                        var idx = rows.indexOf(currentRow);
                        if (idx === -1)
                            return;
                        var next = e.key === 'ArrowDown' ? Math.min(idx + 1, rows.length - 1) : Math.max(idx - 1, 0);
                        var targetRow = rows[next];
                        var focusable = targetRow.querySelector('input[type="checkbox"], button, [tabindex="0"]');
                        if (focusable)
                            focusable.focus();
                        else
                            targetRow.focus();
                    }
                }, children: [(_q = section.children) === null || _q === void 0 ? void 0 : _q.map(function (child) { return (_jsx(CollapsibleSection, { section: child, depth: depth + 1, selectedSet: selectedSet, onCheckToggle: onCheckToggle, onRenameSection: onRenameSection, onRemoveSection: onRemoveSection, onSetSort: onSetSort, onLabelRenamed: onLabelRenamed, onToggleFavourite: onToggleFavourite, onMoveToSection: onMoveToSection, sectionNames: sectionNames }, child.id)); }), section.emptyNoteKey && !((_r = section.entries) === null || _r === void 0 ? void 0 : _r.length) && !((_s = section.children) === null || _s === void 0 ? void 0 : _s.length) && (_jsx("div", { className: "iwb-emptyNote", children: t(section.emptyNoteKey) })), (_t = section.entries) === null || _t === void 0 ? void 0 : _t.map(function (entry) {
                        var _a, _b, _c;
                        var entryKey = entry.id;
                        var isChecked = selectedSet.has(entryKey);
                        return (_jsxs("div", { 
                            // The blue bar marks the code that is OPEN on the canvas, not
                            // the checked one — the client asked for "blue background
                            // display only on code that is open".
                            className: "iwb-entryRow ".concat(entry.isCurrentBuild ? 'iwb-entryRow--current' : ''), role: "listitem", "aria-label": "".concat(formatShareCode(entry.code), " ").concat(entry.label), onKeyDown: function (e) {
                                if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    var btns = Array.from(e.currentTarget.querySelectorAll('button:not([disabled]), input[type="checkbox"]'));
                                    var idx = btns.indexOf(document.activeElement);
                                    if (idx === -1)
                                        return;
                                    var next = e.key === 'ArrowRight'
                                        ? (idx + 1) % btns.length
                                        : (idx - 1 + btns.length) % btns.length;
                                    btns[next].focus();
                                }
                            }, children: [entry.isCurrentBuild ? (_jsx(ButtonComponent, { defaultCSS: "iwb-bullet", normalCSS: "iwb-bullet", imgSrc: (_a = btnConfig.iwbViewCode) === null || _a === void 0 ? void 0 : _a.imgSrc, imgWidth: 22, imgHeight: 22, type: "imageType1", 
                                    // Formatted like the row, checkbox and code box: this is
                                    // the fourth accessible name carrying the code. The bullet
                                    // renders for the open activity's row whatever that
                                    // activity's `shareable` flag says.
                                    ariaLabel: "".concat(t('text.code'), " ").concat(formatShareCode(entry.code)), title: t('text.code'), showToolTip: true, direction: "bottom", isParentRelative: true, clickHandler: function (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setViewCodeEntry({ show: true, code: entry.code });
                                    }, noAudio: true })) : (_jsx("span", { className: "iwb-bullet", "aria-hidden": "true" })), _jsxs("div", { className: "iwb-entryInner", children: [_jsx("span", { className: "iwb-codeBox", role: "button", tabIndex: 0, "aria-label": "".concat(t('text.open'), " ").concat(formatShareCode(entry.code)), onClick: function (e) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setEnterKeyPrefill(entry.code);
                                                setEnterKeyPrefillLabel(entry.label);
                                                setShowEnterKeyModal(true);
                                            }, onKeyDown: function (e) {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setEnterKeyPrefill(entry.code);
                                                    setEnterKeyPrefillLabel(entry.label);
                                                    setShowEnterKeyModal(true);
                                                }
                                            }, children: formatShareCode(entry.code) }), _jsx("input", { className: "iwb-labelBox iwb-labelInput", type: "text", value: (_b = draftLabels[entry.id]) !== null && _b !== void 0 ? _b : entry.label, title: entry.label, "aria-label": "".concat(t('text.renameLabel'), ": ").concat(entry.label || entry.code), 
                                            // A rename re-posts the whole record, so only the owner of
                                            // a saved code may edit it — and never while a save is in
                                            // flight for this row.
                                            disabled: renamingId === entry.id, onClick: function (e) { return e.stopPropagation(); }, onChange: function (e) {
                                                var value = e.target.value;
                                                setDraftLabels(function (prev) {
                                                    var _a;
                                                    return (__assign(__assign({}, prev), (_a = {}, _a[entry.id] = value, _a)));
                                                });
                                            }, onKeyDown: function (e) {
                                                // Stop the row's Arrow handlers hijacking cursor movement.
                                                e.stopPropagation();
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                }
                                                else if (e.key === 'Escape') {
                                                    e.preventDefault();
                                                    setDraftLabels(function (prev) {
                                                        var next = __assign({}, prev);
                                                        delete next[entry.id];
                                                        return next;
                                                    });
                                                    e.target.blur();
                                                }
                                            }, onBlur: function () { return commitLabel(entry); } }), _jsx(ButtonComponent, { defaultCSS: "iwb-favBtn", normalCSS: "iwb-favBtn", imgSrc: (_c = btnConfig.iwbFavourite) === null || _c === void 0 ? void 0 : _c.imgSrc, type: "imageType1", ariaLabel: t('text.addToFavorite'), title: t('text.addToFavorite'), 
                                            // `clickActive` + `isActive` together gate the active
                                            // image (favouriteH) inside ButtonComponent. The
                                            // internal toggle (`buttonActive`) only flips on click,
                                            // so without `controlActiveFromOutside` the button
                                            // would render `favouriteN` for an already-favourited
                                            // entry that the user hasn't just clicked. Letting the
                                            // parent own the active state keeps the icon in sync
                                            // with the persisted `isFavourite` on every render.
                                            clickActive: !!entry.isFavourite, isActive: !!entry.isFavourite, controlActiveFromOutside: true, showToolTip: true, direction: "bottom", clickHandler: function (e) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                onToggleFavourite === null || onToggleFavourite === void 0 ? void 0 : onToggleFavourite(entryKey);
                                            }, noAudio: true }), _jsxs("label", { className: "iwb-checkboxLabel", onClick: function (e) { return e.stopPropagation(); }, children: [_jsx("input", { type: "checkbox", className: "iwb-checkboxInput", checked: isChecked, onChange: function (e) {
                                                        onCheckToggle(entryKey, e.nativeEvent instanceof MouseEvent
                                                            ? e.nativeEvent.shiftKey
                                                            : false);
                                                    }, "aria-label": "".concat(t('text.select'), " ").concat(formatShareCode(entry.code), " ").concat(entry.label) }), _jsx("span", { className: "iwb-checkbox", "aria-hidden": "true", children: _jsx("svg", { className: "iwb-checkTick", width: "10", height: "8", viewBox: "0 0 10 8", fill: "none", children: _jsx("path", { d: "M1 3.5L3.5 6L9 1", stroke: "#fff", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }) })] })] })] }, entry.id));
                    })] })), _jsx(ViewCodeModal
            // Ungated: the modal DISPLAYS the code, and display is never withheld.
            , { 
                // Ungated: the modal DISPLAYS the code, and display is never withheld.
                showModal: viewCodeEntry.show, 
                // Its OK button doubles as copy-to-clipboard, though, and that IS
                // withheld — otherwise un-masking the display would quietly reopen a
                // distribution path (bullet → OK → paste) for exactly the content
                // Copy Link / Copy Code refuse to hand out. The bullet only renders on
                // the open activity's row, so this matches `shareBlocked`'s scope.
                // Explicit `=== false`: an omitted flag must not read as restricted.
                copyOnConfirm: contentShareable !== false, setShowModal: function (show) { return setViewCodeEntry(function (prev) { return (__assign(__assign({}, prev), { show: show })); }); }, code: viewCodeEntry.code }), copyFeedback && (_jsx(Popup, { isOpen: true, onClose: function () { return setCopyFeedback(null); }, ariaLabel: copyFeedback.ok
                    ? copyFeedback.kind === 'link'
                        ? t('text.linkCopied')
                        : copyFeedback.kind === 'image'
                            ? t('text.imageCopied')
                            : t('text.codeCopied')
                    : copyFeedback.reason === 'insecure'
                        ? t('text.copyNeedsSecure')
                        : t('text.copyFailed'), children: _jsxs("div", { className: "iwb-saveInfoModal", role: "dialog", children: [_jsx("p", { className: "iwb-saveInfoMsg", children: copyFeedback.ok
                                ? copyFeedback.kind === 'link'
                                    ? t('text.linkCopied')
                                    : copyFeedback.kind === 'image'
                                        ? ((_u = copyFeedback.info) === null || _u === void 0 ? void 0 : _u.mode) === 'download'
                                            ? t('text.imageDownloaded')
                                            : t('text.imageCopied')
                                        : t('text.codeCopied')
                                : copyFeedback.reason === 'insecure'
                                    ? t('text.copyNeedsSecure')
                                    : t('text.copyFailed') }), _jsx(ButtonComponent, { type: "textType1", text: t('text.ok'), defaultCSS: "iwb-saveInfoOkBtn", normalCSS: "iwb-saveInfoOkBtn", clickHandler: function () { return setCopyFeedback(null); }, ariaLabel: "text.ok" })] }) }))] }));
};
export default CollapsibleSection;
